import {
  CommonRenderHeaderCellProps,
  CommonTableTemplate,
} from 'app/common/templates-next/table-template'

import { Th } from 'app/common/ui-components/table'
import { CellContentCheckSimpleAll } from 'app/common/templates-next/table-template'

import { WarehouseStockTableColumn } from './tableProps'

export const warehouseStockTableRenderHeaderCell = (
  params: CommonRenderHeaderCellProps<Record<string, unknown>, string>,
) => {
  const { columnKey, headerCellProps } = params
  if (columnKey === WarehouseStockTableColumn.Check) {
    return (
      <Th {...headerCellProps}>
        <CellContentCheckSimpleAll />
      </Th>
    )
  }
  return CommonTableTemplate.defaultRenderHeaderCell(params)
}
